export default __webpack_public_path__ + "static/media/al-farabi.212c3c51.jpg";